<template>
    <div class="body fixed mobile">
        <!-- class: fixed, mobile -->
        <!-- Loading Spinner -->
        <!-- <div class="spinner"><div><div></div></div></div> -->
        <!-- Header -->
        <section class="header profile">
            <div class="icon"></div>
            <span class="fL">會員中心</span>
            <NotificationBell @get-point="getPointHandler" />
            <!-- <a
                class="icon iconButton"
                @click.prevent="$router.push('/notification')"
            >
                <img src="@/assets/icon/bell.svg" />
                <div class="new">
                    <span class="fXS white">{{ countUnread }}</span>
                </div>
            </a> -->
        </section>
        <!-- Main -->
        <section class="main profile">
            <div class="flexV width center">
                <div class="img picture" v-if="displayUserImage()"><img :src="displayUserImage()" /></div>
                <div class="img picture" v-else><img src="@/assets/img/profile-d.png" /></div>
                <span class="fM primary">桃園市民</span>
                <span class="fL">{{ displayName() }}</span>
            </div>
            <a
                v-if="!enableStamp"
                class="point flexH between end"
                @click.prevent="$router.push('/record')"
            >
                <div class="flexH">
                    <div class="img">
                        <img src="@/assets/icon/point.svg" />
                    </div>
                    <div class="flexV">
                        <span class="fM">紅利桃子</span>
                        <span class="fXL primary"
                            >{{ displayUserPointBalance
                            }}<span class="fM primary">點</span></span
                        >
                    </div>
                </div>
                <div class="flexV"  v-if="displayDate">
                    <span class="fS">點數到期日</span>
                    <span class="fS">{{ displayDate }}</span>
                </div>
            </a>
            <!--
            <div class="ticket flexH width">
                <a class="flexH width middle disabled">
                    <div class="img">
                        <img src="@/assets/icon/ticket.svg" />
                    </div>
                    <div class="flexV">
                        <span class="fM">優惠卷</span>
                        <span class="fXL third"
                            >0<span class="fM third">張</span></span
                        >
                        <span class="fS">到期日1970/01/01</span>
                    </div>
                </a>
                <div class="lineV"></div>
                <a class="flexH width middle" @click.prevent="$router.push('/stamp-cards')">
                    <div class="img">
                        <img src="@/assets/icon/stamp.svg" />
                    </div>
                    <div class="flexV">
                        <span class="fM">集章</span>
                        <span class="fXL third"
                            >0<span class="fM third">張</span></span
                        >
                        <span class="fS">到期日1970/01/01</span>
                    </div>
                </a>
            </div> -->
            <div class="function flexH rounded">
                <!-- <a class="flexH width middle">
                    <div class="img">
                        <img src="@/assets/icon/favorite.svg" />
                    </div>
                    <span class="fM">我的最愛</span>
                </a> -->
                 <a class="flexH width middle" 
                    @click.prevent="
                        popCode();
                        refreshMemberCode();"
                >
                    <div class="icon primary">
                        <font-awesome-icon icon="fa-solid fa-barcode"></font-awesome-icon>
                    </div>
                    <span class="fM">我的條碼</span>
                </a>
                <div class="lineV"></div>
                <a
                    class="flexH width middle"
                    @click.prevent="$router.push('/profile/edit')"
                >
                    <div class="img"><img src="@/assets/icon/edit.svg" /></div>
                    <span class="fM">編輯個人資料</span>
                </a>
            </div>
            <!-- 功能 -->
            <div v-if="enableStamp" class="functions flexH width padding">
                <a class="flexV center width" @click.prevent="$router.push('/record')">
                    <img src="@/assets/icon/point.svg">
                    <span class="fM">{{ $t('紅利桃子') }}</span>
                    <span class="fS">{{ displayUserPointBalance}}</span>
                </a>
                <a class="flexV center width disabled">
                    <img src="@/assets/icon/ticket.svg">
                    <span class="fM">{{ $t('優惠卷') }}</span>
                    <span class="fS">0{{ $t('張') }}</span>
                </a>
                <a class="flexV center width" @click.prevent="$router.push('/stamp-cards')">
                    <img src="@/assets/icon/stamp.svg">
                    <span class="fM">{{ $t('集章卡') }}</span>
                    <span class="fS">{{ numberOfStampCards }}{{ $t('張') }}</span>
                </a>
            </div>
            <a
                class="invite flexH width rounded middle"
                v-show="displayReferralCode()"
                @click.prevent="popInvite()"
            >
                <span class="fM"
                    >使用<span class="primary">我的邀請碼</span
                    >，邀請朋友！</span
                >
                <div class="img"><img src="@/assets/icon/point.svg" /></div>
            </a>
            <div class="menu flexV width">
                <a
                    class="flexH width between"
                    @click.prevent="$router.push('/appoint-store')"
                >
                    <div class="flexH">
                        <div class="img">
                            <img src="@/assets/icon/store-new.svg" />
                        </div>
                        <span class="fM">特約商店申請</span>
                    </div>
                    <div class="icon gray">
                        <font-awesome-icon
                            icon="fa-solid fa-angle-right"
                        ></font-awesome-icon>
                    </div>
                </a>
                <a
                    class="flexH width between"
                    @click.prevent="logout()"
                >
                    <div class="flexH">
                        <div class="img">
                            <font-awesome-icon icon="fa-solid fa-arrow-right-from-bracket" style="color: #5fb1baab"/>
                            <!-- <img src="@/assets/icon/store-new.svg" /> -->
                        </div>
                        <span class="fM">登出</span>
                    </div>
                    <div class="icon gray">
                        <font-awesome-icon
                            icon="fa-solid fa-angle-right"
                        ></font-awesome-icon>
                    </div>
                </a>
                <!-- <div class="lineH"></div>
                <a class="flexH width between">
                    <div class="flexH">
                        <div class="img">
                            <img src="@/assets/icon/store-admin.svg" />
                        </div>
                        <span class="fM">特約商店後台管理</span>
                    </div>
                    <div class="icon gray">
                        <font-awesome-icon
                            icon="fa-solid fa-angle-right"
                        ></font-awesome-icon>
                    </div>
                </a>
                <div class="lineH"></div>
                <a class="flexH width between">
                    <div class="flexH">
                        <div class="img">
                            <img src="@/assets/icon/stamp-send.svg" />
                        </div>
                        <span class="fM">特約商店集章發送</span>
                    </div>
                    <div class="icon gray">
                        <font-awesome-icon
                            icon="fa-solid fa-angle-right"
                        ></font-awesome-icon>
                    </div>
                </a>
                <div class="lineH"></div>
                <a class="flexH width between">
                    <div class="flexH">
                        <div class="img">
                            <img src="@/assets/icon/setting.svg" />
                        </div>
                        <span class="fM">設定</span>
                    </div>
                    <div class="icon gray">
                        <font-awesome-icon
                            icon="fa-solid fa-angle-right"
                        ></font-awesome-icon>
                    </div>
                </a> -->
            </div>
            
            <div class="flexH width rounded middle">
                <span class="fM gray">v{{version}}</span>
            </div>
        </section>

        <!-- Popup (邀請碼) -->
        <section id="popInvite" class="popup popInvite profile">
            <div class="popBody">
                <a class="close"><font-awesome-icon icon="fas fa-times"></font-awesome-icon></a>
                <section class="popHeader">
                    <span class="fL primary">我的邀請碼</span>
                </section>
                <section class="popMain">
                    <div class="flexH">
                        <div class="img">
                            <img src="@/assets/icon/invite.svg" />
                        </div>
                        <!-- <div class="flexV">
                            <span class="fM">成功邀請朋友</span>
                            <span class="fL third">10</span>
                        </div> -->
                    </div>
                </section>
                <section class="popFooter">
                    <a
                        class="button rounded code white"
                        @click.prevent="copy()"
                    >
                        <div class="flexH">
                            <div class="icon">
                                <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon>
                            </div>
                            <span v-show="isCopied" class="fS gray"
                                >已複製</span
                            >
                        </div>
                        <span class="fM">{{ displayReferralCode() }}</span>
                        <input
                            type="hidden"
                            id="referral-code"
                            :value="generateReferralCode()"
                        />
                    </a>
                    <a class="button rounded line" :href="shareWithLINEUrl()">
                        <div class="img">
                            <img src="@/assets/icon/line.svg" />
                        </div>
                        <span class="fM">Line邀請好友</span>
                    </a>
                </section>
            </div>
        </section>
        <!-- Popup (Code) -->
        <section ref="popCode" id="popCode" class="popup scan popCode">
            <div class="popBody">
                <a class="close" @click.prevent="codeClose()"
                    ><font-awesome-icon icon="fas fa-times"></font-awesome-icon
                ></a>
                <section class="popHeader">
                    <span class="fL primary center">我的條碼</span>
                </section>
                <section class="popMain">
                    <div class="flexH width between">
                        <div class="img profile">
                            <img :src="userImageUrl" />
                        </div>
                        <div class="flexV width">
                            <span class="fL">{{ displayName() }}</span>
                            <span class="fM gray">{{
                                displayIdNo
                            }}</span>
                        </div>
                        <div class="flexV center">
                            <a class="refresh icon iconButton white" @click.prevent="refreshMemberCode()">
                                <font-awesome-icon icon="fa-solid fa-arrows-rotate"></font-awesome-icon>
                            </a>
                            <span class="fXS gray center">{{displayTimerToMinutes()}}<br>更新</span>
                        </div>
                    </div>
                    <div class="qrcode flexH width middle">
                        <div class="img">
                            <QrcodeVue :value="memberCode" size="250" level="H"/>
                        </div>
                    </div>
                    <div class="qrcode flexH width center">
                        <barcode :value="memberCode" format="code128" width="2">
                            {{memberCode}}
                        </barcode>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState, mapGetters } from "vuex";
import NotificationBell from '@/components/NotificationBell.vue';
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";

export default {
    name: "Profile",
    components: {
        NotificationBell,
        barcode: VueBarcode,
        QrcodeVue
    },
    data() {
        return {
            apiHost: process.env.VUE_APP_API_HOST,
            merchantId: process.env.VUE_APP_MERCHANT_ID,
            isCopied: false,
            appHost: process.env.VUE_APP_HOST+process.env.BASE_URL,
            myReferralCode: "",
            isNotificationBar: false,
            notificationBarContent: {
                title: "",
                message: "",
                time: "",
                points: "",
                reset: function () {
                    this.title = "";
                    this.message = "";
                    this.time = "";
                    this.points = "";
                }
            },
            firstNotification: {},
            userData: {},
            memberCode: "",
            intervalId: "",
            defaultTimerSec: 300,
            timer: 300,
            stampCards: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        // called before the route that renders this component is confirmed.
        // does NOT have access to `this` component instance,
        // because it has not been created yet when this guard is called!
        console.log(to, from);
        next((vm) => {
            let that = vm;
            console.log("user: ", that.user);
            if (that.user && that.user.userId) {
                vm.getUserPoints()
                    .then((res) => {
                        that.$store.commit("updateUserPoints", res);

                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        next("/error");
                    });
                vm.$store.commit(
                    "updateUserInfo",
                    Object.assign({}, vm.userInfo, {
                        myReferralCode: vm.user.user.myReferralCode
                    })
                );
                vm.myReferralCode = vm.user.user.myReferralCode;
            } else {
                next("/error");
            }
        });
    },
    created() {},
    mounted() {
        this.getUserData();
        this.getStampCards();
    },
    computed: {
        ...mapState(["user", "userInfo", "currentPath"]),
        ...mapGetters({
            userPoints: "getTyUserPoints"
        }),
        displayDate() {
            return this.lastestEndOfPoint ? this.tsToData(this.lastestEndOfPoint.endTs): "";
            // return this.tsToData(
            //     this.userPoints &&
            //         this.userPoints.pointPeriods &&
            //         this.userPoints.pointPeriods.length > 0
            //         ? this.userPoints.pointPeriods[0].endTs
            //         : null
            // );
        },
        
        displayIdNo() {
            return this.user && this.user.user && this.user.user._json
                ? this.user.user._json.idno
                : "";
        },
        
        version() {
            return process.env.PACKAGE_VERSION;
        },
        displayUserPointBalance() {
            return this.userPoints && this.userPoints.pointBalance
                ? this.userPoints.pointBalance
                : 0;
        },
        userImageUrl() {
            return this.user && this.user.user && this.user.user._json
                ? this.user.user._json.picture
                : "";
        },
        lastestEndOfPoint() {
            if (
                this.userPoints &&
                this.userPoints.pointPeriods &&
                this.userPoints.pointPeriods.length > 0
            ) {
                let sorted = [...this.userPoints.pointPeriods];
                sorted.sort(function(a, b) {
                    return a.endTs - b.endTs;
                })
                const latestEndOfPoint = sorted.find(p => p.endTs >= moment().unix());
                return latestEndOfPoint;
            }
            return null;
        },
        numberOfStampCards(){
            return this.stampCards ? this.stampCards.length : 0;
        },
        enableStamp(){
            return process.env.VUE_APP_ENABLE_STAMP ==='true' ;
        }
    },
    methods: {
        dummyUserData() {
            let result = {
                "memberId": 47,
                "uuid": null,
                "oauthId": "U38a079aadef4a60ec5a6263112248b35",
                "picture": "https://profile.line-scdn.net/0hNwmZpXdREVhQIzrAyWRuD2xmHzUnDRcQKEJdOHIlGmt1RFIHOEFXPSUiH2x4EFIHaBZebiErSW4p",
                "idno": "H223292882",
                "name": "Kay Lai",
                "birthdate": "1988-03-05",
                "phoneNumber": "0921185084",
                "carrier": null,
                "gender": 1,
                "email": "clearsky0305@gmail.com",
                "fullAddress": "桃園市平鎮區",
                "isTyCitizen": 1,
                "createdTs": 1647945287
            }
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({data: result});
                }, 300);
            })
        },
        callUserDataAPI() {
            var config = {
                method: 'get',
                url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${this.user.userId}`,
                headers: { }
            };

            return this.$http(config)
                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    return response;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getUserData() {
            this.callUserDataAPI()
            // this.dummyUserData()
            .then(res => {
                this.userData = res.data;
            })
            .catch(err => {
                console.log("err: ", err);
                this.$router.push('/error');
            })
        },
        displayReferralCode() {
            return this.user.user.myReferralCode;
        },
        displayName() {
            return this.userData.name;
        },
        displayUserImage() {
            return this.userInfo ? this.userInfo.picture : "";
        },
        tsToData(ts) {
            return moment(ts * 1000).format("YYYY-MM-DD");
        },
        getUserPoints() {
            var config = {
                method: "get",
                url: `${this.apiHost}/points/v1/merchants/${this.merchantId}/members/${this.user.userId}/points`,
                headers: {}
            };

            return this.$http(config)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        popInvite() {
            var popInvite = document.getElementById("popInvite");
            var close = popInvite.getElementsByClassName("close")[0];
            close.onclick = function () {
                popClose();
            };
            window.onclick = function (event) {
                if (event.target == popInvite) {
                    popClose();
                }
            };
            function popClose() {
                popInvite.style.display = "none";
                document.body.style.overflow = "scroll";
            }
            popInvite.style.display = "flex";
            document.body.style.overflow = "hidden";
        },
        copy() {
            let textToCopy = document.querySelector(`#referral-code`);
            console.log("referralCode: ", textToCopy.value);
            textToCopy.setAttribute("type", "text");
            textToCopy.select();
            var successful = document.execCommand("copy");
            if (successful) {
                this.isCopied = true;
            }
            textToCopy.setAttribute("type", "hidden");
        },
        generateReferralCode() {
            return this.myReferralCode;
        },
        generateReferralUrl() {
            return encodeURIComponent(`${this.appHost}?referralCode=${this.myReferralCode}`);
        },
        shareWithLINEUrl() {

            return `https://line.me/R/share?text=${this.generateReferralUrl()}`;
        },
        getPointHandler(event) {
            console.log("get points: ", event);
            this.updateUserPoints();
        },
        updateUserPoints() {
            this.getUserPoints()
                .then((res) => {
                    console.log("update user points!");
                    this.$store.commit("updateUserPoints", res);
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.router.push("/error");
                });
        },
        logout() {
            qcsso.logout({logoutRedirectUri: this.appHost.substring(0, this.appHost.length - 1)})
            .then(() => console.log("success"))
            .catch(err => console.log(err));
        },
        popCode() {
            this.$refs["popCode"].style.display = "flex";
        },
        codeClose() {
            this.$refs["popCode"].style.display = "none";
        },
        displayTimerToMinutes() {
            let mins = Math.floor(this.timer / 60);
            let secs = (this.timer % 60).toString().padStart(2, '00');
            return `${mins}:${secs}`;
        },
        refreshMemberCode() {
            this.loading = true;
            this.periodRefreshMemberCode();
            this.getMemberCode()
                .then((memberCodeRes) => {
                    this.memberCode = memberCodeRes.data.oneTimeKey;
                    this.loading = false;
                })
                .catch((memberCodeErr) => {
                    console.log("memberCodeErr: ", memberCodeErr);
                    this.loading = false;
                });
        },
        clearTimer() {
            clearInterval(this.intervalId);
            this.timer = this.defaultTimerSec;
            this.memberCode = "";
            this.intervalId = "";
        },
        periodRefreshMemberCode() {
            this.clearTimer();
            this.intervalId = setInterval(() => {
                this.timer--;
                if (this.timer <= 0) {
                    this.refreshMemberCode();
                }
            }, 1000);
        },
        getMemberCode() {
            let config = {
                url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${this.user.userId}/one-time-keys/pay`,
                method: "POST"
            };
            return this.$http(config);
        },
        callGetStampCardsAPI() {
            let config = {
                // url: `${this.apiHost}/stamps/v1/merchants/${this.merchantId}/collector/${this.user.userId}/stamp-cards`
                url: `${this.apiHost}/stamps/v1/merchants/${this.merchantId}/stamp-cards?uuid=${this.user.userId}`

            };
            console.log("config: ", config)
            return this.$http(config);
        },
        getStampCards() {
            this.callGetStampCardsAPI()
                .then((res) => {
                    this.stampCards = res.data;
                   console.log("callGetStampCardsAPI: ", res.data);
                })
                .catch((err) => console.log(err));
        },
    }
};
</script>

<style scoped>
.version {
  font-size: 8px;
  color: #8080807a;
}
</style>